export const installerCompanyTabsStyles = (theme) => ({
  tabSelected: {
    backgroundColor: theme.palette.grey[100],
  },
})
